import { HTTP } from './http';

import config from 'config';

const baseUrl = config.mdLiveApi;

export const requestAllMessages = (pageNo, filter) =>
  new Promise((resolve, reject) =>
    HTTP.get(`/messages?${pageNo}&${filter}=true`)
      .then(response => ((response.status === 200) ? resolve : reject)(response))
      .catch(error => reject(error.response))
  );

export const requestMessageById = id =>
  new Promise((resolve, reject) =>
    HTTP.get(`/messages/${id}`)
      .then(response => ((response.status === 200) ? resolve : reject) (response))
      .catch(error => reject(error.response))
  );

export const requestSendMessage = model =>
  new Promise((resolve, reject) =>
    HTTP.post('/messages', model)
      .then(response => ((response.status === 201) ? resolve : reject)(response))
      .catch(error => reject(error.response))
  );

export const markMessageAsRead = id =>
  new Promise((resolve, reject) =>
    HTTP.put(`/messages/${id}/mark-read`)
      .then(response => ((response.status === 204) ? resolve : reject)(response))
      .catch(error => reject(error.response))
  );

export const requestAllContacts = () =>
  new Promise((resolve, reject) =>
    HTTP.get('/contacts')
      .then(response => ((response.status === 200) ? resolve : reject) (response))
      .catch(error => reject(error.response))
  );

export const requestContactById = id =>
  new Promise((resolve, reject) =>
    HTTP.get(`/contacts/${id}`)
      .then(response => ((response.status === 200) ? resolve : reject) (response))
      .catch(error => reject(error.response))
  );

// export const requestUnreadCount = () =>
//   new Promise((resolve, reject) =>
//     HTTP.get('/messages/unread-messages-count')
//       .then(response => (( response.status === 200) ? resolve : reject) (response))
//       .catch(error => reject(error.response))
//   );

export const sendDocument = model =>
  new Promise((resolve, reject) =>
    HTTP.post(`${baseUrl}/v2/patients/${model.id}/documents`, model.file)
      .then(response => (( response.status === 201) ? resolve: reject) (response))
      .catch(error => reject(error.response))
  );


export const sendDocumentMeta = model =>
  new Promise((resolve, reject) =>
    HTTP.post('/documents', model)
      .then(response => (( response.status === 201) ? resolve: reject) (response))
      .catch(error => reject(error.response))
  );

export const requestAllConversations = id =>
  new Promise((resolve, reject) =>
    HTTP.get(`/messages/${id}/conversations`)
      .then(response => ((response.status === 200) ? resolve : reject) (response))
      .catch(error => reject(error.response))
  );

export const markAsRead = model =>
  new Promise((resolve, reject) =>
    HTTP.put(
      `${baseUrl}/v2/patients/${model.patient}/conversations/${model.id}/mark_as_read`, {
        headers : {
          Authorization: `Bearer ${model.token}`,
        },
      }
    )
      .then(response => (response.status === 200 ? resolve : reject)(response))
      .catch(error => reject(error.response))
  );



// WEBPACK FOOTER //
// ./client/api/messaging.js